"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarGroupAvatarsRoot = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const AvatarGroupAvatarsRoot = (0, _styled.default)("div")`
    display: inline-flex;
    isolation: isolate;

    // All but the first Avatar should be clipped on the left.
    & > *:not(:first-of-type) {
        clip-path: ${_ref => {
  let {
    leftClipModeId
  } = _ref;
  return `url("#${leftClipModeId}")`;
}};
    }

    // But, if an Avatar has focus the Avatar immediately to its left should be clipped on the left
    // and right, except for the first Avatar, which should only be clipped on the right.
    //
    // This isn't supported by FF yet (https://bugzilla.mozilla.org/show_bug.cgi?id=418039), but the
    // impact is minimal. The JS-based alternative is quite messy.
    & > *:not(:first-of-type):has(+ * > *:focus-visible) {
        clip-path: ${_ref2 => {
  let {
    bothClipModeId
  } = _ref2;
  return `url("#${bothClipModeId}")`;
}};
    }

    // If the second avatar has focus, the first avatar should only be clipped on the right.
    //
    // This isn't supported by FF yet (https://bugzilla.mozilla.org/show_bug.cgi?id=418039), but the
    // impact is minimal. The JS-based alternative is quite messy.
    & > *:first-of-type:has(+ * > *:focus-visible) {
        clip-path: ${_ref3 => {
  let {
    rightClipModeId
  } = _ref3;
  return `url("#${rightClipModeId}")`;
}};
    }

    & > *:has(> *:focus-visible) {
        clip-path: none;
    }
`;
exports.AvatarGroupAvatarsRoot = AvatarGroupAvatarsRoot;
//# sourceMappingURL=AvatarGroupAvatarsRoot.js.map